import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import RootState, { AppDispatch } from './index';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<typeof RootState> = useSelector;
